module.exports = __webpack_public_path__ + "img/finance1.c27818ca.svg";